export default __webpack_public_path__ + "static/media/dribbble_1.181c5a64.gif";